import React from "react";
import { Redirect, useParams } from "react-router-dom";

export function WebTrackerDetailsPageRedirect() {
  const { trackerId } = useParams<{ trackerId: string }>();
  return <Redirect to={`/monitoring/trackingTools/${trackerId}`} />;
}
